/* eslint-disable @typescript-eslint/no-explicit-any */
import { APIResponse } from '@/types';
import httpService from '../httpService';
import {
    ProductInfoResponse,
    ProductStockInfoRequest,
    ProductStockResponse,
    SetProductStockInfoRequest,
} from '@/types/pages/storeManagement/stockControl';

export const handleGetProductInformation = (data: ProductStockInfoRequest): APIResponse<ProductInfoResponse> => {
    return httpService.get('/bond/information', {
        params: data,
    });
};
export const handleSetProductStockStatus = (data: SetProductStockInfoRequest): APIResponse<ProductStockResponse> => {
    return httpService.post('/bond/inventory_state', data);
};
